/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */
const region_country_dict = {
  'ANZ': ['Australia', 'New Zealand'],
  'SEA': ['India', 'Pakistan', 'Bangladesh', 'Sri Lanka', 'Nepal', 'Bhutan', 'Maldives', 'Afghanistan', 'Indonesia', 'Malaysia', 'Singapore', 'Philippines', 'Thailand', 'Brunei', 'Vietnam', 'Myanmar', 'Cambodia', 'Laos', 'Timor-Leste', 'Japan', 'South Korea', 'North Korea', 'Taiwan', 'Mongolia'],
  'GRC': ['China'],
  'EMEA': ['United Kingdom', 'France', 'Germany', 'Italy', 'Spain', 'Russia', 'Poland', 'Netherlands', 'Belgium', 'Greece', 'Portugal', 'Sweden', 'Norway', 'Denmark', 'Finland', 'Ireland', 'Switzerland', 'Austria', 'Czech Republic', 'Hungary', 'Romania', 'Bulgaria', 'Serbia', 'Croatia', 'Ukraine', 'Belarus', 'Lithuania', 'Latvia', 'Estonia', 'Moldova', 'Albania', 'Bosnia and Herzegovina', 'Montenegro', 'North Macedonia', 'Slovenia', 'Slovakia', 'Luxembourg', 'Malta', 'Iceland', 'Andorra', 'Monaco', 'Liechtenstein', 'San Marino', 'Vatican City',
    'Saudi Arabia', 'Iran', 'Turkey', 'Iraq', 'United Arab Emirates', 'Israel', 'Jordan', 'Lebanon', 'Syria', 'Yemen', 'Oman', 'Kuwait', 'Qatar', 'Bahrain',
    'Nigeria', 'Ethiopia', 'Egypt', 'Democratic Republic of the Congo', 'South Africa', 'Tanzania', 'Kenya', 'Algeria', 'Sudan', 'Morocco', 'Angola', 'Mozambique', 'Ghana', 'Madagascar', 'Cameroon', 'Ivory Coast', 'Niger', 'Burkina Faso', 'Mali', 'Malawi', 'Zambia', 'Senegal', 'Chad', 'Somalia', 'Zimbabwe', 'Guinea', 'Rwanda', 'Benin', 'Burundi', 'Tunisia', 'South Sudan', 'Togo', 'Sierra Leone', 'Liberia', 'Central African Republic', 'Mauritania', 'Eritrea', 'Namibia', 'Gambia', 'Botswana', 'Gabon', 'Lesotho', 'Guinea-Bissau', 'Equatorial Guinea', 'Mauritius', 'Eswatini', 'Djibouti', 'Comoros', 'Cabo Verde', 'Sao Tome and Principe', 'Seychelles'],
  'NAM': ['United States', 'Canada', 'Mexico', 'Guatemala', 'Belize', 'Honduras', 'El Salvador', 'Nicaragua', 'Costa Rica', 'Panama', 'Cuba', 'Jamaica', 'Haiti', 'Dominican Republic', 'Bahamas'],
  'LAM': ['Brazil', 'Argentina', 'Colombia', 'Peru', 'Venezuela', 'Chile', 'Ecuador', 'Bolivia', 'Paraguay', 'Uruguay', 'Guyana', 'Suriname', 'French Guiana'],
  'PA_team': [],
};
// The 'getDefaultValue' function retrieves the default value from the antiscalant dictionary.
// If no default value is found, it returns an object with 'UNTREATED' set to 1.
// It then filters the keys of the default object where the value is 1 and returns the result.
export function getDefaultValue(dbTransactionDetails) {
  const value = dbTransactionDetails?.antiscalant_dict?.Default || { 'UNTREATED': 1 };
  const result = Object.keys(value).filter(key => value[key] === 1);
  return result;
};
export function getUserType() {
  const getUserEmail = sessionStorage.getItem('user_email');
  return getUserEmail?.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
}
// The 'getRegionAccess' function checks the user's access to the region based on their email.
// It first retrieves the user's email and determines the user type based on the email domain.
// If the user is an internal user, it checks if the user is in the users dictionary.
// If the user is found, it checks the user's account type.
// If the user is an 'WF5 Administrator' or 'MemChem CoE', it returns true; otherwise, it returns false.
// If the user is not found in the dictionary, it returns false.
// If the user is an external user, it returns false.
export function getRegionAccess(dbTransactionDetails) {
  const getUserEmail = sessionStorage.getItem('user_email');
  if (getUserType() === 'internal') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes('WF5 Administrator') || userValue.AccountType.includes('MemChem CoE')) {
        return true;
      }
      return false;
    }
    return false;
  }
};
export function getNFfeedAndCLROFrom(dbTransactionDetails, str = 'NF Module') {
  const getUserEmail = sessionStorage.getItem('user_email');
  // const getUserEmail = 'anitha-sravya.chanumolu@veolia.com';
  if (getUserType() === 'internal') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes(str) || userValue.AccountType.includes('WF5 Administrator')) {
        return true;
      }
      return false;
    }
    return false;
  };
  return false;
}
export function getArgoFromAccess(dbTransactionDetails) {
  const getUserEmail = sessionStorage.getItem('user_email');
  // const getUserEmail = 'anitha-sravya.chanumolu@veolia.com';
  if (getUserType() === 'internal') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes('MemChem CoE') || userValue.AccountType.includes('WF5 Administrator')) {
        if(process.env.REACT_APP_ENV !== 'prod'){
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  };
  return false;
}
export function externalaccess(dbTransactionDetails) {
  const getUserEmail = sessionStorage.getItem('user_email');
  if (getUserType() === 'external') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes('Channel Patner')) {
        return true;
      }
      return false;
    }
    return false;
  }
  return false;
};
export function getMassBalanceAccess(dbTransactionDetails) {
  const getUserEmail = sessionStorage.getItem('user_email');
  if (getUserType() === 'internal') {
    if (Object.prototype.hasOwnProperty.call(dbTransactionDetails.users_dict, getUserEmail)) {
      const userValue = dbTransactionDetails.users_dict[getUserEmail];
      if (userValue.AccountType.includes('WF5 Administrator')) {
        return true;
      }
      return false;
    }
    return false;
  };
  return false;
};
// 'Products' is a function that provides a list of products for a given region.
// It first attempts to find the region in the antiscalant dictionary.
// If the region is not found, it defaults to a predefined value.
// It then identifies keys in the region-specific object that have a value of 1.
// If there are any such keys, they are returned; if not, the default value is returned.
export function Products(dbTransactionDetails, region) {
  // Check if user is internal or has external access
  if ((getUserType() === 'internal') || (getUserType() === 'external' && externalaccess(dbTransactionDetails))) {
    const filteredObj = dbTransactionDetails.antiscalant_dict[region];
    if (!filteredObj) {
      return getDefaultValue(dbTransactionDetails);
    }
    const result = Object.keys(filteredObj).filter(key => filteredObj[key] === 1);
    return result.length ? result : getDefaultValue(dbTransactionDetails);
  }
  return getDefaultValue(dbTransactionDetails);
};

// 'getRegion' is a function that returns an object with all available regions and the currently selected region.
// It extracts all regions from the region_country_dict and also includes the current region.
export function getRegion() {
  let country = sessionStorage.getItem('country');
  if (!country && localStorage.getItem('unit_set_dict') && Object.keys(JSON.parse(localStorage.getItem('unit_set_dict'))).length > 0) {
    country = JSON.parse(localStorage.getItem('unit_set_dict')).country;
  }
  const region = Object.keys(region_country_dict).find(key => region_country_dict[key].includes(country));
  return {
    'regions': Object.keys(region_country_dict),
    'region': region,
  };
}